import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthInitializer from './components/AuthInitializer';
import AdminLayout from './components/AdminLayout';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import UsersManagement from './pages/UsersManagement';
import CompaniesManagement from './pages/CompaniesManagement';
import CompanyDetail from './pages/CompanyDetail';
import CompanyUsers from './pages/CompanyUsers';
import SubscriptionsManagement from './pages/SubscriptionsManagement';
import PlansManagement from './pages/PlansManagement';
import InvoicesManagement from './pages/InvoicesManagement';
import SupportTickets from './pages/SupportTickets';
import ChatbotsOverview from './pages/ChatbotsOverview';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import SystemSettings from './pages/SystemSettings';
import APIKeysManagement from './pages/APIKeysManagement';
import ActivityLog from './pages/ActivityLog';
import RolesManagement from './pages/RolesManagement';
import AdminProfile from './pages/AdminProfile';
import NewsletterManagement from './pages/NewsletterManagement';

function App() {
  return (
    <AuthInitializer>
      <BrowserRouter>
        <Routes>
          {/* Redirect root to admin login */}
          <Route path="/" element={<Navigate to="/admin/login" replace />} />
          
          {/* Admin Login - Public Route */}
          <Route path="/admin/login" element={<AdminLogin />} />
          
          {/* Protected Admin Routes */}
          <Route path="/admin" element={
            <ProtectedAdminRoute>
              <AdminLayout />
            </ProtectedAdminRoute>
          }>
            {/* Dashboard */}
            <Route index element={<AdminDashboard />} />
            
            {/* Platform Users - Admin users only */}
            <Route path="users" element={<UsersManagement />} />
            
            {/* Companies */}
            <Route path="companies" element={<CompaniesManagement />} />
            <Route path="companies/users" element={<CompanyUsers />} />
            <Route path="companies/:id" element={<CompanyDetail />} />
            
            {/* Subscriptions */}
            <Route path="subscriptions" element={<SubscriptionsManagement />} />
            <Route path="subscriptions/plans" element={<PlansManagement />} />
            <Route path="subscriptions/invoices" element={<InvoicesManagement />} />
            
            {/* Chatbots */}
            <Route path="chatbots" element={<ChatbotsOverview />} />
            
            {/* Analytics */}
            <Route path="analytics" element={<AnalyticsDashboard />} />
            
            {/* Support */}
            <Route path="support/tickets" element={<SupportTickets />} />
            
            {/* System */}
            <Route path="system/settings" element={<SystemSettings />} />
            <Route path="system/api-keys" element={<APIKeysManagement />} />
            <Route path="system/roles" element={<RolesManagement />} />
            
            {/* Activity */}
            <Route path="activity" element={<ActivityLog />} />

            {/* Newsletter */}
            <Route path="newsletter" element={<NewsletterManagement />} />

            {/* Profile */}
            <Route path="profile" element={<AdminProfile />} />
          </Route>

          {/* 404 - Redirect to login */}
          <Route path="*" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthInitializer>
  );
}

export default App;
